import GlossaryResearchTooltip from "../../tooltips/glossaryScreen/GlossaryResearchTooltip";
import GlossaryResearchModeIcon from "../../icons/glossaryScreen/GlossaryResearchModeIcon";
import GlossaryResearchModeText from "../../texts/glossaryScreen/GlossaryResearchModeText";

export default function GlossaryResearchModeButton({isStrictMode, setIsStrictMode}) {
    // Used in GlossaryResearch to switch between flex and strict mode

    // BUILD
    return (
        <div className="relative group flex justify-center items-center">
            <button className="whitespace-nowrap select-none flex justify-end items-center space-x-[4px] text-greyLight7 hover:text-greyLight9 pr-[8px]"
                    onClick={() => setIsStrictMode(!isStrictMode)}>
                <GlossaryResearchModeIcon isStrictMode={isStrictMode} />
                <GlossaryResearchModeText isStrictMode={isStrictMode} />
            </button>
            <GlossaryResearchTooltip isStrictMode={isStrictMode} />
        </div>
    )
}